module.exports = __webpack_public_path__ + "img/title_hr.35feaee.svg";